import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const PartnerProtectedRoute = ({ children, allowPasswordChange = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A1128] grid place-items-center" data-testid="partner-auth-loading">
        <div className="h-10 w-10 rounded-full border-2 border-[#C9A24E]/30 border-t-[#C9A24E] animate-spin" />
      </div>
    );
  }
  if (!user || user === false) return <Navigate to="/partner/login" replace />;
  if (user.role !== 'Marketing_Partner') return <Navigate to="/unauthorized" replace />;
  if (user.must_change_password && !allowPasswordChange) {
    return <Navigate to="/partner/change-password" replace />;
  }
  if (!user.must_change_password && allowPasswordChange && location.pathname === '/partner/change-password') {
    return <Navigate to="/partner" replace />;
  }
  return children;
};